import {ComponentChildren, toChildArray, VNode} from "preact";
import {AsRoute} from "../../app";
import Router from "preact-router";
import {Link} from "preact-router/match";
import styled from "styled-components";
import {Columns} from "./columns";
import {darken} from "polished";

type TabProperties = {
    title: string;
    children?: ComponentChildren;
} & AsRoute;

const TabContent = styled.div`
    padding: 1rem;
    flex-grow: 1;
    
    > ${Columns} {
        margin-left: -.5rem;
        margin-right: -.5rem;
    }
`;

export function Tab(props: TabProperties) {
    return <TabContent>{props.children}</TabContent>;
}

type TabsProperties = {
    children?: VNode<TabProperties>[];
};

const TabList = styled.ul`
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;
    
    > li {
        background: ${props => darken(.1, props.theme.colors.cardBg)};
        color: ${props => props.theme.colors.cardFg};
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        flex-grow: 1;
        
        >a, >button, &:not(:has(>a, >button)) {
            padding: 1rem .4rem;
            cursor: pointer;
        }
        
        >a, >button, >a.btn, >button.btn {
            display: flex;
            text-decoration: none;
            justify-content: center;
            
            &:hover {
                font-weight: normal;
            }
        }
        
        .tab-selected, &.tab-selected {
            background: ${props => props.theme.colors.cardBg};
            color: ${props => props.theme.colors.cardFg};
        }
    }
`;

export const Tabs = styled(function (props: TabsProperties) {
    const tabs: VNode<TabProperties>[] = toChildArray(props.children) as VNode<TabProperties>[];

    return <div {...props}>
        <TabList>
            {tabs.map((tab, index) =>
                <li><Link href={tab.props.path} activeClassName="tab-selected">{tab.props.title}</Link></li>
            )}
        </TabList>
        <Router>
            {tabs}
        </Router>
    </div>
})`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    background: ${props => props.theme.colors.cardBg};
    color: ${props => props.theme.colors.cardFg};
    
    margin-left: 1rem;
    margin-right: 1rem;
    margin-bottom: 1rem;
`;
